import * as yup from 'yup';

const NEW_PASSWORD_ERROR = `
  New Password is a required field <br/>
  Password should contain 8 characters and at least one number, one uppercase letter, one lowercase letter, and one special characters e.g. ! @ # $ & * - + ;
`;

const PASS_CODE_ERROR = `
  You should have received a One Time Passcode in a text message <br/>
  One Time Passcode is required
`;

const schema = yup.object({
  username: yup
    .string()
    .default('')
    .label('New Username')
    .min(3, 'Username must be at least 3 characters long')
    .required()
    .matches(/^[^/]*$/, {
      message: "Username cannot contain a '/' character",
      excludeEmptyString: true,
    }),
  password: yup
    .string()
    .label('New Password')
    .min(8, NEW_PASSWORD_ERROR)
    .required()
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^\w\s]).{8,}$/,
      NEW_PASSWORD_ERROR
    )
    .default(''),
  matchPassword: yup
    .string()
    .label('Confirm Password')
    .required()
    .oneOf([yup.ref('password')], 'Confirm Password not matched')
    .default(''),
  otp: yup
    .string()
    .label('One Time Passcode')
    .required(PASS_CODE_ERROR)
    .default('')
    .length(6, 'OTP must be exactly 6 characters'),
});

export default schema;
